import { Typography } from "@mui/material";
import React from "react";

export default function CoreTypographyCaption(props) {
  return (
    <Typography {...props} variant="caption" display="block" gutterBottom>
      {props.children}
    </Typography>
  );
}
